import React from "react";

/**
 * Shared editorial block: eyebrow + title area (keeps existing title classes).
 */
function SectionIntro({ eyebrow, children, className = "" }) {
  return (
    <div className={`vh-section-intro ${className}`.trim()}>
      {eyebrow ? (
        <p className="section__subtitle block-title vh-eyebrow">{eyebrow}</p>
      ) : null}
      {children}
    </div>
  );
}

export default SectionIntro;
